import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Paper, Stack, Textarea, rem, Text } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { UploadPhoto } from '@/components/upload-photo';
import { useBookingStore } from '@/stores/booking/booking-store-provider';
type ModalContentProps = {
  onClose: () => void;
};

const MAX_CHARACTERS = 250;

export default function NoteContent({ onClose }: ModalContentProps) {
  const tBooking = useTranslations('booking');

  const { remarks, setRemarks, images, setImages } = useBookingStore(
    (state) => state
  );

  const [selectedImages, setSelectedImages] = useState<string[]>(images ?? []);
  const noteSchema = z.object({
    remarks: z.string().max(1000, { message: tBooking('note.max_characters') }),
    images: z.array(z.string()).max(3).nullable().optional(),
  });

  type FormData = z.infer<typeof noteSchema>;
  const form = useForm<FormData>({
    resolver: zodResolver(noteSchema),
    defaultValues: {
      remarks: remarks ?? '',
      images: images ?? [],
    },
  });
  const onSelectedImages = (imgUrls: string[]) => {
    setSelectedImages(imgUrls);
    form.setValue('images', imgUrls);
  };
  const onSubmit = (values: FormData) => {
    const sanitizedRemarks =
      values.remarks?.trim() === '' ? null : values.remarks;
    setRemarks(sanitizedRemarks);
    setImages(values.images ?? []);

    onClose();
  };
  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Stack
        styles={{
          root: {
            height: 'inherit',
            backgroundColor: 'white',
          },
        }}
        pt={16}
        gap={60}
        justify="space-between"
        align="stretch"
      >
        <Paper>
          <Stack>
            <Stack gap={rem(4)}>
              <Textarea
                // data-autofocus
                size="md"
                error={form.formState.errors.remarks?.message}
                styles={{
                  input: {
                    // minHeight: 56,
                    '::placeholder': {
                      color: 'var(--mantine-color-neutral-5)',
                    },
                  },
                }}
                placeholder={tBooking('note.place_holder_input')}
                rows={6}
                maxRows={6}
                maxLength={MAX_CHARACTERS}
                {...form.register('remarks')}
              />

              <Text size="xs" c="neutral.6" fw={500} ta="right">
                {form.watch('remarks')?.length ?? 0}/{MAX_CHARACTERS}
              </Text>
            </Stack>
            <UploadPhoto
              maxPhotoUpload={3}
              images={selectedImages}
              onChange={onSelectedImages}
            />
          </Stack>
        </Paper>
        <Box w="100%" bg="white">
          <Button size="md" fullWidth mih={rem(48)} type="submit">
            {tBooking('note.confirm')}
          </Button>
        </Box>
      </Stack>
    </form>
  );
}
